import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ExtendPermitModal = ({ permit, onClose, onConfirm }) => {
  const [extensionData, setExtensionData] = useState({
    newEndDate: '',
    reason: ''
  });

  const handleSubmit = (e) => {
    e?.preventDefault();
    onConfirm(permit?.id, extensionData);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
              <Icon name="Clock" size={20} className="text-blue-600 dark:text-blue-400" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Extend Permit</h2>
              <p className="text-sm text-muted-foreground">{permit?.permitId}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-muted rounded transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Current End Date:</span>
              <span className="font-medium text-foreground">
                {new Date(permit.endDate)?.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Location:</span>
              <span className="font-medium text-foreground">{permit?.location}</span>
            </div>
          </div>

          <Input
            label="New End Date"
            type="date"
            required
            value={extensionData?.newEndDate}
            onChange={(e) => setExtensionData({ ...extensionData, newEndDate: e?.target?.value })}
            min={new Date(permit.endDate)?.toISOString()?.split('T')?.[0]}
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Reason for Extension <span className="text-red-500">*</span>
            </label>
            <textarea
              required
              value={extensionData?.reason}
              onChange={(e) => setExtensionData({ ...extensionData, reason: e?.target?.value })}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 resize-none"
              rows="4"
              placeholder="Provide detailed reason for permit extension..."
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
              iconName="Check"
              className="flex-1"
            >
              Confirm Extension
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExtendPermitModal;